import React from 'react';
import { cx } from './cx';

export interface EmptyStateProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/** Centred empty or "nothing here yet" state. */
export default function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cx('flex flex-col items-center gap-2.5 px-4 py-8 text-center', className)}>
      <span aria-hidden className="mb-1 inline-flex size-12 items-center justify-center rounded-full border border-edge-subtle bg-inset text-secondary [&>svg]:size-5.5">
        {icon}
      </span>
      <p className="m-0 font-ui text-body font-semibold text-primary">{title}</p>
      {description ? <p className="m-0 max-w-sm font-ui text-small text-secondary">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
